import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScCtaButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (${device.mobile}) {
    width: 100%;
  }

  &.promoButton {
    @media (${device.mobile}) {
      margin-top: 32px;
    }
  }

  button {
    min-width: 280px;
  }
`;
